import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { SafePipe } from '../../../../shared/pipes/safe.pipe';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { environment } from '../../../../../environments/environment';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { CXENTRY_BARCODE_SCAN_MESSAGE } from '../../../../shared/constants/cx-entry';

@Component({
  selector: 'app-cx-entry-modal',
  standalone: true,
  imports: [
    ModalComponent,
    SafePipe,
    TranslatePipe
  ],
  templateUrl: './cx-entry-modal.component.html',
  styleUrl: './cx-entry-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CxEntryModalComponent extends BaseModalComponent {

  @ViewChild('entryIframe') entryIframe?: ElementRef<HTMLIFrameElement>;

  public readonly environment = environment;

  public get isOpen(): boolean {
    return this.modalComponent?.isOpened() ?? false;
  }

  public get entryTargetOrigin(): string {
    return new URL(this.environment.cxEntryUrl).origin;
  }

  public forwardBarcodeScan(code: string): void {
    const trimmed = code.trim();

    if (!trimmed || !this.isOpen) {
      return;
    }

    const contentWindow = this.entryIframe?.nativeElement?.contentWindow;

    if (!contentWindow) {
      return;
    }

    contentWindow.postMessage(
      { type: CXENTRY_BARCODE_SCAN_MESSAGE, code: trimmed },
      this.entryTargetOrigin
    );
  }
}
